export default {
  border: {
    width: '0.0625rem',
    hover: {
      width: '0.1875rem',
    },
  },
  selected: {
    border: {
      width: '0.5rem',
    },
  },
  height: '1.625rem',
  width: '1.625rem',
  margin: '0.625rem',
};
